import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { FHEBoxAutoComplete } from 'data/components';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import selectors from '../../selectors';

class Step1 extends PureComponent {
    static propTypes = {
        boxMac: PropTypes.string.isRequired,
        setMacAddress: PropTypes.func.isRequired,
        prefixFheCenter: PropTypes.string.isRequired,
        boxesArray: PropTypes.array.isRequired
    };

    constructor(props) {
        super(props);
    }

    handleSelect = (name, mac, id) => {
        const { setMacAddress } = this.props;
        setMacAddress(mac, id);
    };

    render() {
        const { prefixFheCenter, boxesArray, boxMac } = this.props;
        return (
            <Grid container spacing={3} justify="center" alignItems="center">
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEBoxAutoComplete
                        id="boxMac"
                        baseValue={boxMac === null || !boxMac ? prefixFheCenter : boxMac}
                        label={Translator.translate(`general.table.column.boxMac`, Translator.translate(`fhe.centerName`))}
                        name="boxMac"
                        data={boxesArray}
                        selectData={this.handleSelect}
                    />
                </Grid>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        boxesArray: selectors.getBoxesArray(state),
        prefixFheCenter: selectors.getPrefixFheCenter(state)
    };
}

export default connect(mapStateToProps)(Step1);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/components/stepper/Step1.js